export enum ProductSpecificationType {
  FUNCTIONALITY = 'functionality',
  TECHNICAL_DATA = 'technical_data',
  LOGISTIC_DATA = 'logistic_data',
}
